import { Plus } from 'lucide-react';
import { Trans } from '@lingui/react/macro';

export interface BillingAddressPlaceholderCardProps {
  onAdd: () => void;
}

export function BillingAddressPlaceholderCard({ onAdd }: BillingAddressPlaceholderCardProps) {
  return (
    <button
      type="button"
      onClick={onAdd}
      className="rounded-2xl border-2 border-dashed border-border bg-card flex flex-col items-center justify-center gap-2 text-muted-foreground hover:border-primary/50 hover:text-primary hover:bg-primary/5 transition-colors min-h-[160px] w-full"
    >
      <div className="flex size-9 items-center justify-center rounded-xl bg-muted">
        <Plus size={18} />
      </div>
      <span className="text-sm font-medium">
        <Trans>Add address</Trans>
      </span>
    </button>
  );
}
